import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { useNavigationHooks } from "..";
import { useDealFormIdSelect, useViewActions } from "../../store";
import { INotification, UrlQueryParams } from "../../store/types";
import { JSON_to_URLEncoded } from "../../utils";
import { NotificationHandlerType } from "./use-click-handler";

export function useSurveyCommentHook(): NotificationHandlerType {
  const formId: number | undefined = useDealFormIdSelect();
  const { scrollToAnswerAction, commentsScrollAction } = useViewActions();
  const { getFormPathName } = useNavigationHooks();
  const { push } = useHistory();

  return useCallback(async ({ components }: INotification) => {
    const searchObj: UrlQueryParams = {
      section: components.section_id,
      answer: components.question_uuid, //TODO - refactor this, after migration to question primary key for notifications
      comment: components.comment_id,
      question: components.question_id,
      highlight: components.comment_id
    };
    if (components.form_id) {
      searchObj.questionComment = components.form_id;
      push({
        pathname: getFormPathName(components.deal_id, components.form_id),
        search: JSON_to_URLEncoded(searchObj)
      });
      if (!formId) {
        scrollToAnswerAction("on");
      }
      commentsScrollAction(true);
    }
  }, []);
}
